import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import PagesLayout from './PagesLayout';
import Form from 'antd/lib/form';
import Button from 'antd/lib/button';
import { Col, Input, Row } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import {Link} from 'react-router';
import rules from '../../common/rules/rules';
import ReCAPTCHA from 'react-google-recaptcha';
import config from '../../config'
import { accountRoles } from '../../common/enums';
 

const { Item } = Form
 
  const formItemLayout = {
    labelCol: {
      xs: {
        span: 9,
      },
      sm: {
        span: 6,
      },
    },
    wrapperCol: {
      xs: {
        span: 15,
      },
      sm: {
        span: 14,
      },
    },
  };

  let captcha;

@translate()
@Form.create()
export default class Pomoc extends Component{


    static propTypes = {
        isLoggedIn: PropTypes.bool.required,
        form: PropTypes.object.isRequired,
        t: PropTypes.func.isRequired,
        onSubmit: PropTypes.func.isRequired,
        account: PropTypes.object,
    };
    handleSubmit = e => {
        e.preventDefault();

        const { form,  onSubmit } = this.props
        form.validateFields((err,values) => {
            if(!err){
                onSubmit(values)
            }
        })
        if (captcha){
          captcha.execute()
          captcha.reset()
        }
        
    }

    render(){

        const { t, isLoggedIn, account } = this.props
        const { getFieldDecorator } = this.props.form

        return(
            <PagesLayout noImg >
              
                <h1>Potrebujete pomôcť?</h1>

                {
                  !isLoggedIn ?
                  <p>Máte otázku ohľadom nášho
                    fungovania? Hlavné otázky a odpovede o našom fungovaní nájdete tiež na stránkach 
                    <Link to={{
                        pathname: "onboarding/creditor",
                        state: {fromHelp: true}
                      }}> Najčastejšie kladene otázky investorov</Link>
                      , alebo <Link to={{
                       pathname: "onboarding/debtor",
                       state: {fromHelp: true}
                     }}> Najčastejšie kladene otázky žiadateľov</Link>.</p> :
                     <p>
                       Máte otázku ohľadom nášho
                       fungovania? Hlavné otázky a odpovede o našom fungovaní nájdete tiež na stránkach
                       {
                         account.role === accountRoles.DEBTOR ?
                         <Link to="/info-debtor"> Najčastejšie kladene otázky žiadateľov</Link> 
                         :
                         <Link to="/info-creditor"> Najčastejšie kladene otázky investorov</Link>
                       } 
                     .</p>
                     
                 } 
                 
                    
                
                <section className="onboarding-form">
                  <Form layout="vertical" onSubmit={this.handleSubmit}>
                    {!isLoggedIn && (
                      <Row>
                        <Col xs={15} sm={14}>
                          <Item {...formItemLayout}>
                            {getFieldDecorator('name', { rules: rules.characterLimitOnName })(
                            <Input placeholder={t("Vaše meno")}></Input>
                          )}
                        </Item>
                        </Col>
                        <Col xs={15} sm={14}>
                          <Item {...formItemLayout}>
                            {getFieldDecorator('email', {rules: rules.emailRequired})(
                            <Input placeholder={t("Váš email")}></Input>
                            )} 
                          </Item>
                        </Col>
                      </Row>
                         
                      )}
                        
                      
                      {!isLoggedIn && (
                        <ReCAPTCHA
                          ref={ (el) => {captcha = el} }
                          size="invisible"
                          sitekey={`${config.captcha_site_key}`}
                          onChange={this.onChange}
                        />
                      )}

                      <Row>
                        <Col xs={15} sm={14}>
                          <Item>
                            {getFieldDecorator('question', { rules : rules.characterLimitOnQuestion })(
                              <TextArea rows={5} cols={10} placeholder="S čím Vám môžeme pomôcť?"></TextArea>
                            )}       
                          </Item>
                        </Col>
                      </Row>
                      
                        <Item style={{alignSelf: "center"}} className="sendButton">
                            <Button type="primary" size="default" htmlType="submit" >
                                {t('Odoslať')}
                            </Button>
                        </Item>         
                     </Form>
                </section>     
            </PagesLayout>
        );
    }
}




// WEBPACK FOOTER //
// ./src/features/pages/Pomoc.js